// extracted by mini-css-extract-plugin
export default {"planCard":"planCard_planCard__gfOxX","planCardTitle":"planCard_planCardTitle__8BWxW"};